import styled from "styled-components";
import { COLORS } from "../../../shared";

export const MixtureListChooseStyled = styled.div`
  margin-bottom: 20px;
  .mixture {
    &-choose {
      &__items {
        display: flex;
        align-items: center;
        &.is-loading {
          pointer-events: none;
          opacity: 0.6;
        }
      }
      &__item {
        margin-right: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        background: none;
        outline: none;
        border: none;
        padding: 0;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          .mixture-choose__icon {
            &::before {
              opacity: 1;
            }
          }
        }
      }
      &__icon {
        position: relative;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 5px;
        border: 1px solid ${COLORS.PRIMARY_DARK};
        &::before {
          content: "";
          width: 80%;
          height: 80%;
          top: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: ${COLORS.PRIMARY_DARK};
          border-radius: 50%;
          transition: all 0.3s ease-in-out;
          opacity: 0;
        }
      }
    }
  }
`;
